import { render, staticRenderFns } from "./SelectAddress.vue?vue&type=template&id=6012717c&scoped=true&"
import script from "./SelectAddress.vue?vue&type=script&lang=js&"
export * from "./SelectAddress.vue?vue&type=script&lang=js&"
import style0 from "./SelectAddress.vue?vue&type=style&index=0&id=6012717c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6012717c",
  null
  
)

export default component.exports